<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group label-for="Schools">
        <template slot="label">
          Ecole <span class="text-danger">*</span>
        </template>
        <b-form-select id="Schools" name="Schools" v-model="schoolId" :options="schools_list" data-vv-as="Ecole" v-validate="'required'" @change="getEstablishment(); getTypes();"></b-form-select>
        <div v-show="errors.has('Schools')" class="alert alert-danger mt-3">{{ errors.first('Schools') }}</div>
      </b-form-group>
      <b-form-group label="Campus" label-for="Establishments" v-show="schoolId != ''">
        <b-form-select id="Establishments" name="Establishments" v-model="establishmentId" :options="establishments" data-vv-as="Campus"></b-form-select>
        <div v-show="errors.has('Establishments')" class="alert alert-danger mt-3">{{ errors.first('Establishments') }}</div>
      </b-form-group>
      <b-form-group label-for="Types">
        <template slot="label">
          Type <span class="text-danger">*</span>
        </template>
        <b-form-select id="Types" name="Types" v-model="typeId" :options="types" data-vv-as="Type" v-validate="'required'"></b-form-select>
        <div v-show="errors.has('Types')" class="alert alert-danger mt-3">{{ errors.first('Types') }}</div>
      </b-form-group>
      <b-form-group>
        <b-btn variant="secondary" @click.prevent="toggleShow" v-show="!id">Choisir un fichier</b-btn>
        <image-crop-upload
          @crop-success="cropSuccess"
          v-model="showUpload"
          :width="333"
          :height="186"
          img-format="jpg"
          lang-type="fr"
          :no-circle="true"
          :no-rotate="false"
        ></image-crop-upload>
        <img :src="image">
      </b-form-group>
      <b-form-group>
        <b-form-checkbox id="bydefault" v-model="bydefault">
          Image par défaut
        </b-form-checkbox>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/images/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import ImageCropUpload from 'vue-image-crop-upload'

Vue.use(VueResource)

export default {
  components: {
    'image-crop-upload': ImageCropUpload
  },
  data () {
    return {
      button: '',
      bydefault: false,
      establishmentId: '',
      establishments: [{ value: '', text: '--- Sélectionnez un campus ---' }],
      h1: '',
      image: '',
      schoolId: '',
      schools_list: [{ value: '', text: '--- Sélectionnez une école ---' }],
      showUpload: false,
      types: [{ value: '', text: '--- Sélectionnez un type ---' }],
      typeId: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'schools', 'userId']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    cropSuccess (image, field) {
      this.image = image
    },
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.id) {
            this.$http.post(this.domain + '/api/images?access_token=' + this.access_token, { name: this.image, schoolId: this.schoolId, establishmentId: this.establishmentId, typeId: this.typeId, bydefault: this.bydefault, ionisId: this.userId }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('L\'image a bien été ajoutée', {
                    title: 'Image ajoutée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/images/list')
                }
              })
            }, (response) => {

            })
          } else {
            this.$http.post(this.domain + '/api/images/' + this.id + '/replace?access_token=' + this.access_token, { name: this.image, schoolId: this.schoolId, establishmentId: this.establishmentId, typeId: this.typeId, bydefault: this.bydefault }, { emulateJSON: true }).then((response) => {
              response.json().then((data) => {
                if (response.status === 200 && response.ok) {
                  this.$root.$bvToast.toast('L\'image a bien été modifiée', {
                    title: 'Image modifiée',
                    autoHideDelay: 3000,
                    append: false,
                    variant: 'success'
                  })
                  this.$router.push('/images/list')
                }
              })
            }, (response) => {

            })
          }
        }
      })
    },
    getEstablishment () {
      this.$http.get(this.domain + '/api/establishments?filter[where][schoolId]=' + this.schoolId + '&filter[include]=city&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            this.establishments.push(
              {
                value: data[i].id,
                text: data[i].city.name
              }
            )
          }
        })
      }, (response) => {

      })
    },
    getTypes () {
      this.types = [{ value: '', text: '--- Sélectionnez un type ---' }]
      this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            let type = data[i].schools.find(a => a.id === this.schoolId)
            console.log(type)
            if (type !== undefined) {
              this.types.push({
                value: data[i].id,
                text: data[i].name
              })
            }
          }
        })
      }, (response) => {

      })
    },
    toggleShow () {
      this.showUpload = !this.showUpload
    }
  },
  mounted () {
    // document.getElementById('nom_ecole').focus()
    // this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
    //   response.json().then((data) => {
    //     this.schools = data
    //   })
    // }, (response) => {

    // })
    // this.$http.get(this.domain + '/api/types?filter[order]=name ASC&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
    //   response.json().then((data) => {
    //     for (let i = 0; i < data.length; i++) {
    //       this.types.push(
    //         {
    //           value: data[i].id,
    //           text: data[i].name
    //         }
    //       )
    //     }
    //   })
    // }, (response) => {

    // })
    if (this.id) {
      this.$http.get(this.domain + '/api/images/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.schoolId = data.schoolId
          this.establishmentId = data.establishmentId === 'undefined' ? '' : data.establishmentId
          this.typeId = data.typeId
          this.image = data.name
          this.bydefault = data.bydefault
          this.getEstablishment()
          this.getTypes()
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer une image'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter une image'
    }
    if (this.$route.query.schoolId !== undefined && this.$route.query.typeId !== undefined) {
      this.schoolId = this.$route.query.schoolId
      this.typeId = this.$route.query.typeId
    }
    for (let i = 0; i < this.schools.length; i++) {
      this.schools_list.push(
        {
          value: this.schools[i].id,
          text: this.schools[i].name
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Images/Edit.vue